module.exports = __webpack_public_path__ + "static/lezaki-basen-ed9fd03437b6770cb80fb46da98c6625.jpg";